import { subDays } from 'date-fns';

export const RECALC_TRANSACT_TIME_INTERVAL_MINUTES = 15;

export function getRecalcNowTransactTime(now: Date): Date {
  const result = new Date(now);
  const minutes = result.getMinutes();
  result.setMinutes(
    Math.floor(minutes / RECALC_TRANSACT_TIME_INTERVAL_MINUTES) * RECALC_TRANSACT_TIME_INTERVAL_MINUTES,
    0,
    0
  );
  return result;
}

export function getRecalcTransactTimeBounds(now: Date): { minValue: Date; maxValue: Date } {
  return {
    minValue: subDays(now, 14),
    maxValue: getRecalcNowTransactTime(now),
  };
}

export function normalizeRecalcTransactTime(selected: Date, now: Date): Date {
  const { minValue, maxValue } = getRecalcTransactTimeBounds(now);
  const clamped = Math.min(Math.max(selected.getTime(), minValue.getTime()), maxValue.getTime());
  return getRecalcNowTransactTime(new Date(clamped));
}
